export const smallestZoomLevel = 'xs'
